export const GLOBAL_LINK_TILE_ROUTES = {
  info_feed: "/info_feed",
  geo: "/geo",
  geo_political_widget: "/global_link/geo_political_widget",
  geo_political_tile_1: "/global_link/geo_political_tile_1",
  geo_political_tile_2: "/global_link/geo_political_tile_2",
  geo_political_tile_3: "/global_link/geo_political_tile_3",
  geo_political_tile_4: "/global_link/geo_political_tile_4",
  co_trader_tile_1: "/global_link/co_trader_tile_1",
  co_trader_tile_2: "/global_link/co_trader_tile_2",
  bestx_pre_trade: "/global_link/bestx_pre_trade",
  best_x_tile_1: "/global_link/best_x_tile_1",
  trade_analysis: "/global_link/trade_analysis",
  co_hedger_tile_1: "/global_link/co_hedger_tile_1",
  co_trader_currency_chat: "/global_link/co_trader_currency_chat",
  co_trader_forward_tile_1: "/global_link/co_trader_forward_tile_1",
  co_trader_forward_tile_2: "/global_link/co_trader_forward_tile_2",
  co_trader_fx_forward_app: "/global_link/co_trader_fx_forward_app",
  co_trader_fx_app: "/global_link/co_trader_fx_app",
  user_profile: "/global_link/user_profile",
  about_us: "/global_link/about_us",
  faq: "/global_link/faq",
  co_trader_insights: "/global_link/co_trader_insights",
  co_trader_insight_widget: "/global_link/co_trader_insight_widget",
  co_trader_price_widget: "/global_link/co_trader_price_widget",
};

export const DEFAULT_POST_SSO_ROUTE = "/default-page";

export const resolveGlobalLinkTileRoute = (tileKey) => {
  if (!tileKey) {
    return null;
  }

  return GLOBAL_LINK_TILE_ROUTES[tileKey] || null;
};

export const getPostSsoRedirectUrl = ({
  tileKey,
  originalUrl,
  fallbackUrl = DEFAULT_POST_SSO_ROUTE,
}) => {
  const tileRoute = resolveGlobalLinkTileRoute(tileKey);
  if (tileRoute) {
    return tileRoute;
  }

  if (originalUrl) {
    return originalUrl;
  }

  return fallbackUrl;
};
